"use client";

import { EMBEDDED_WALLET_CONNECTOR_ID } from "../../lib/wagmi";
import { useConnectorId } from "./useConnectorId";
export function useIsEmbeddedWallet() {
  const connectorId = useConnectorId();
  return Boolean(connectorId) && connectorId === EMBEDDED_WALLET_CONNECTOR_ID;
}